var _g, _path, _g2, _g3, _path2, _g4, _g5, _path3, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#66c6b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384 306c56-55 128-87 128-156 0-37-30-68-67-68-27 0-50 16-61 39a68 68 0 0 0-61-39c-37 0-67 31-67 68 0 70 76 102 128 156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 316a33 33 0 0 1-48 0c5-7 15-12 15-21h17c0 9 10 13 16 21z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479 123c8 8 11 19 6 22-4 3-13 0-21-10-7-8-11-19-6-22 3-3 13 1 21 10z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#415a6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395 302h-20c-3 0-4-1-4-3s1-4 4-4h20c2 0 3 2 3 4 0 1-1 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 324l-3-2 2-4c3-1 5-2 5-8 1-7 9-12 10-13 1-2 3-2 4 1 1 1 1 3-1 4s-6 5-6 9c0 8-4 11-11 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 369c-18-31-10-70-10-70v-1h-7c-1 3-7 41 12 74 17 31-9 87-9 88-1 2 0 3 1 4h1l4-2c1-2 27-59 8-93z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#f3705a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 235c58-59 134-92 134-164 0-39-32-71-70-71-28 0-53 16-63 41A74 74 0 0 0 71 0C32 0 0 32 0 71c0 73 80 106 135 164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 244a35 35 0 0 1-50 0c5-7 16-11 16-21h18c0 8 11 14 16 21z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234 42c8 9 10 20 6 23-4 4-15 0-22-10-9-9-11-20-7-23 5-4 14 0 23 10z",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#415a6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 229h-21c-2 0-3-1-3-3s1-3 3-3h21c2 0 3 1 3 3 1 1-1 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 253l-3-2 2-5c3-1 6-2 7-7 1-8 8-14 9-15s3-1 4 1c2 1 2 3-1 4-2 1-6 6-7 10 0 8-3 12-11 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 300c-19-33-12-74-11-74v-1h-6c-2 3-8 44 11 78 18 32-8 91-9 92-1 2 0 4 2 4h1l3-2c1-1 29-62 9-97z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd15c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 396c53-53 122-83 122-147 0-36-29-64-64-64-26 0-47 14-58 36a64 64 0 0 0-57-36c-36 0-64 28-64 64 0 65 72 94 121 147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 403a31 31 0 0 1-45 0c5-6 15-10 15-19h16c0 9 9 13 14 19z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346 221c7 8 9 18 6 21s-13 0-20-8c-8-9-10-19-7-22 4-3 13 0 21 9z",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#415a6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267 390h-19c-3 0-4-1-4-3s1-3 4-3h19c2 0 3 1 3 3l-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 412l-3-2c0-3 1-4 2-5 3-1 5-2 5-6 1-8 9-13 9-13 1-1 3-1 4 1 1 1 1 3-1 4-2 2-6 6-6 9 0 6-4 11-10 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269 510c0 3 6 3 6 0 5-18 7-40-3-56-17-29-9-66-9-66v-1h-7c-1 3-6 40 11 71 8 15 6 35 2 52z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloons);
export default __webpack_public_path__ + "static/media/balloons.4ccb9738ef3a9c60a8921a1c6a9039a2.svg";
export { ForwardRef as ReactComponent };